export default __webpack_public_path__ + "static/media/ad_300x250_install@2x.a4189ccc.png";